
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / heart","xmlns":"http://www.w3.org/2000/svg","width":"19.5","height":"17.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.75 17.5a2.453 2.453 0 01-.81-.314l-.307-.164-.333-.193-.364-.218-.385-.24c-.066-.041-.131-.084-.2-.128l-.406-.267-.414-.283-.417-.3-.413-.3-.406-.309-.2-.156-.384-.312C1.585 11.716 0 9.089 0 6.51a6.841 6.841 0 011.745-4.533A5.771 5.771 0 016.05 0a5.4 5.4 0 013.517 1.235l.183.157.184-.157A5.361 5.361 0 0113.153.007L13.45 0a5.773 5.773 0 014.305 1.977A6.84 6.84 0 0119.5 6.51c0 2.578-1.585 5.206-4.711 7.808l-.19.156-.392.312-.406.309-.206.153-.416.3-.416.29-.41.275-.4.259-.569.352-.352.206-.322.178-.29.149a2.028 2.028 0 01-.67.243zm-3.7-16a4.3 4.3 0 00-3.222 1.52A5.318 5.318 0 001.5 6.51a6.223 6.223 0 001.1 3.332 14.993 14.993 0 003.07 3.323 25.783 25.783 0 003 2.137l.193.117.028.017.414.241c.115.065.236.132.369.2l.079.042.448-.245c.135-.077.275-.158.415-.241l.22-.133a25.869 25.869 0 003-2.137A14.993 14.993 0 0016.9 9.842 6.223 6.223 0 0018 6.51a5.318 5.318 0 00-1.328-3.49A4.3 4.3 0 0013.45 1.5a3.983 3.983 0 00-3.132 1.45.75.75 0 01-1.136 0A3.98 3.98 0 006.05 1.5z","fill":"#011936"}})])
          )
        }
      }
    